<template>
    <div class="policy-footer mt-4 text-center">
        <p class="policy-text text-xs text-[#6B7280]">
            By booking you also agree to our
            <a href="https://nativeamericantours.com/privacy-policy.html" class="policy-link text-[#2563EB] underline">policies</a>,
            and Stripe
            <a href="https://stripe.com/legal/end-users" class="policy-link text-[#2563EB] underline">terms of service</a>.
        </p>
    </div>
</template>

<script>
export default {
    name: 'PolicyFooter'
};
</script>